import { Column } from '@nerdwallet/currency/components/Column';
import { Columns } from '@nerdwallet/currency/components/Columns';

import BottomLink from './bottom-link';
import { bottomLinks } from './constants';

const BottomLinks = () => (
  <Columns collapse>
    {bottomLinks?.map((link) => (
      <Column key={link?.title} width="6">
        <BottomLink linkItem={link} />
      </Column>
    ))}
  </Columns>
);

export default BottomLinks;
